import React from 'react';
import ShowDeletedCompaniesButton from "./ShowDeletedCompaniesButton";
import {Link} from 'react-router-dom';

class CompaniesListHeading extends React.Component {
    constructor(props) {
        super(props);
    }


    _applyLinkStyle() {
        if (this.props.mobile) {
            return 'col-sm-12';
        }

        return 'pull-right'
    }

    render() {
        return (
            <div className="row p-0">
                <div className="col-7"><h1>Virksomhed</h1></div>
                <div className={this.props.mobile ? 'col-sm-12 pt-2' : 'col-sm-3 pt-2'}>
                    <ShowDeletedCompaniesButton
                        mobile={this.props.mobile}
                        listId={this.props.listId}
                        tablet={this.props.tablet}
                    />
                </div>
                <div className={this.props.mobile ? 'col-sm-12 pt-2 m-b-10' : 'col-sm-2 pt-2'}>
                <Link to="/profil/skab" className={`btn btn-primary waves-effect ${this._applyLinkStyle()}`} data-create-company-button>
                    Opret virksomhed</Link>
                </div>
            </div>
        );
    }
}

export default CompaniesListHeading;


// WEBPACK FOOTER //
// ./web/src/components/company/list/CompaniesListHeading.jsx